<template>
    <card-collapsable title="Dados de medidores triortogonais" start-visible>
        <b-row align-h="center" cols="1">
            <b-col>
                <triaxial-joint-selector
                    ref="triaxialJointSelector"
                    :disabled="loading"
                />
            </b-col>
            <b-col class="mt-4">
                <concrete-thermometer-selector
                    ref="concreteThermometerSelector"
                    :disabled="loading"
                />
            </b-col>
            <b-col>
                <date-range-selector
                    ref="dateSelector"
                    label="Intervalo de tempo"
                    :disabled="loading"
                />
            </b-col>
            <b-col>
                <b-form-group label="Dados de interesse">
                    <b-form-checkbox-group
                        v-model="interestedData"
                        :options="interestedDataOptions"
                        :disabled="loading"
                        switches
                    />
                </b-form-group>
            </b-col>
            <b-col v-if="validationMessage.length > 0">
                <b-alert variant="danger" :show="true">{{
                    validationMessage
                }}</b-alert>
            </b-col>
            <b-col class="text-center">
                <b-overlay
                    :show="loading"
                    class="d-inline-block"
                    variant="white"
                    spinner-small
                >
                    <b-button class="pl-1" :disabled="loading" @click="update">
                        <i class="fas fa-sm fa-sync-alt mx-1" />
                        Atualizar gráfico
                    </b-button>
                </b-overlay>
            </b-col>
        </b-row>
    </card-collapsable>
</template>

<script>
import sleep from "@/utils/sleep";
import CardCollapsable from "@/components/CardCollapsable";
import DateRangeSelector from "@/components/DateRangeSelector";
import TriaxialJointSelector from "./components/TriaxialJointSelector";
import ConcreteThermometerSelector from "./components/ConcreteThermometerSelector";

export default {
    name: "TriaxialJointFilter",
    components: {
        CardCollapsable,
        DateRangeSelector,
        TriaxialJointSelector,
        ConcreteThermometerSelector
    },
    data() {
        return {
            loading: false,
            interestedData: ["measure", "simulation"],
            validationMessage: ""
        };
    },
    computed: {
        interestedDataOptions() {
            return [
                {
                    text: "Medição",
                    value: "measure"
                },
                {
                    text: "Simulação",
                    value: "simulation"
                }
            ];
        }
    },
    methods: {
        async update() {
            this.validationMessage = "";
            this.loading = true;
            this.$emit("start-loading");
            await this.$nextTick();
            await sleep(500);

            const params = {
                triaxialJoints: this.$refs.triaxialJointSelector.selected.map(
                    item => ({ ...item })
                ),
                concreteTemperatureThermometers: this.$refs.concreteThermometerSelector.selected.map(
                    item => ({ ...item })
                ),
                dateInterval: this.$refs.dateSelector.value,
                interestedData: [...this.interestedData]
            };

            if (this.isValid(params)) {
                const vm = this;

                this.$emit("update", {
                    params,
                    callback() {
                        vm.loading = false;
                        vm.$emit("finish-loading");
                    }
                });
            } else {
                this.loading = false;
                this.$emit("finish-loading");
            }
        },
        isValid(params) {
            if (params.triaxialJoints.length === 0) {
                this.validationMessage = "Nenhum medidor selecionado.";
                return false;
            }

            if (params.concreteTemperatureThermometers.length === 0) {
                this.validationMessage = "Nenhum termômetro selecionado.";
                return false;
            }

            if (params.interestedData.length === 0) {
                this.validationMessage =
                    "Nenhum dado de interesse selecionado.";
                return false;
            }
            this.validationMessage = "";
            return true;
        }
    }
};
</script>
